import React from 'react';
import { StyledListTitle } from './styled-list-title';

const FrameStatic = ({ title, children }: { title: string; children: React.ReactNode }) => {
    return (
        <>
            <StyledListTitle>{title}</StyledListTitle>
            {children}
        </>
    );
};

export default FrameStatic;
